module.exports = __webpack_public_path__ + "img/reports_allegati.e074d0fe.png";